import * as Yup from 'yup'
import { type EditContactFormState } from '../model/types'
import { validatePhoneNumber } from '@/shared/helpers/validatePhoneNumber'
import { ContactTitle } from '@/shared/api/topli/TopliApi'
import { TFunction } from 'i18next'

export const editContactFormDefault: EditContactFormState = {
  id: 0,
  is_client: false,
  name: '',
  second_name: '',
  title: null,
  phone: '',
  phone2: '',
  email: '',
  is_man: true,
  user_id: null,
}

export const editContactFormSchema = (t: TFunction) => {
  return Yup.object().shape({
    is_client: Yup.boolean(),
    name: Yup.string()
      .required(t('common:validation_messages.required'))
      .max(127, t('common:validation_messages.max', { count: 127 })),
    second_name: Yup.string()
      .required(t('common:validation_messages.required'))
      .max(127, t('common:validation_messages.max', { count: 127 })),
    title: Yup.mixed()
      .oneOf(Object.values(ContactTitle) as number[], t('common:validation_messages.invalid_value'))
      .nullable(),
    is_man: Yup.boolean(),
    phone: Yup.string()
      .required(t('common:validation_messages.required'))
      .test('phone', t('common:validation_messages.invalid_phone'), value =>
        validatePhoneNumber(value),
      ),
    phone2: Yup.string()
      .optional()
      .test('phone2', t('common:validation_messages.invalid_phone'), value => {
        if (!value) return true
        else return validatePhoneNumber(value)
      })
      .nullable(),
    email: Yup.string()
      .email(t('common:validation_messages.invalid_email'))
      .max(63, t('common:validation_messages.max', { count: 63 }))
      .nullable(),
    user_id: Yup.number().required(t('common:validation_messages.required')),
  })
}
